// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import GAuth from 'vue-google-oauth2'
import VueCookies from 'vue-cookies'
import { VLazyImagePlugin } from "v-lazy-image";
import VModal from 'vue-js-modal'
import VueZoomer from 'vue-zoomer'
import 'vue-zoomer/dist/vue-zoomer.css'

Vue.use(VueZoomer)

Vue.use(VModal)

Vue.config.productionTip = false

const gauthOption = {
  clientId: '666459687804-ips7hu6vv1q62h523b41etu89qe4mdsr.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}

Vue.use(GAuth, gauthOption)

Vue.use(VueCookies)

Vue.use(VLazyImagePlugin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js